import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./AdvantagesBanner.module.scss";
import {getShopId} from "../getShopId";
import {AdvantageBannerSwiper} from "../../swipers/advantageBannerSwiper";
import {useMediaQuery} from "react-responsive";

const AdvantagesBanner: React.FC = () => {
  const {t} = useTranslation();

  const isMobile = useMediaQuery({maxWidth: 767});

  const swiperCartAdvantageBanner: HTMLElement | null = document.querySelector("#AdvantageCartBannerSwiper");
  if (swiperCartAdvantageBanner) {
    new AdvantageBannerSwiper(swiperCartAdvantageBanner);
  }

  return (
    <>
      {/* --Mobile Swiper-- */}
      {isMobile && (
        <div className="legacy-swiper">
          <div id="AdvantageCartBannerSwiper" className="swiper-container advantage-banner--swiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <span className="advantage-banner--content">
                  <span className="icon icon-check--green"></span>
                  <span>
                    {t("general.30DaysReturnPolicy")}
                    {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
                  </span>
                </span>
              </div>
              <div className="swiper-slide">
                <span className="advantage-banner--content">
                  <span className="icon icon-check--green"></span>
                  <span>
                    {t("general.freeReturnsForParcelGoods")}
                    {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
                  </span>
                </span>
              </div>
              <div className="swiper-slide">
                <span className="advantage-banner--content">
                  <span className="icon icon-check--green"></span>
                  <span> {t("general.24000products--cnt", {cnt: Intl.NumberFormat([]).format(24000)})}</span>
                </span>
              </div>
            </div>
            <div className="advantage-banner--prev-button advantage-banner--button--white">
              <span className="icon icon-chevron-left">&#160;</span>
            </div>
            <div className="advantage-banner--next-button advantage-banner--button--white">
              <span className="icon icon-chevron-right">&#160;</span>
            </div>
          </div>
        </div>
      )}

      {/* --Desktop List-Version-- */}
      {!isMobile && (
        <div className={styles.listWrapper}>
          <ul>
            <li>
              <span className="icon icon-check--green" />
              {t("general.30DaysReturnPolicy")}
              {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
            </li>
            <li>
              <span className="icon icon-check--green" />
              {t("general.freeReturnsForParcelGoods")}
              {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
            </li>
            <li>
              <span className="icon icon-check--green" />
              {t("general.24000products--cnt", {cnt: Intl.NumberFormat([]).format(24000)})}
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default AdvantagesBanner;
